import API from "../../utils/api";

export const getCourierServiceCostsApi = async (filters) => {
  const response = await API.get("settings/courier-service-cost", { params: filters });
  return { response };
};

export const getCourierServiceCostDeliveryPartnersApi = async () => {
  const response = await API.get("settings/courier-service-cost/delivery-partners");
  return { response };
};

export const addCourierServiceCostApi = async (data) => {
  const response = await API.post("settings/courier-service-cost", data);
  return { response };
};

export const updateCourierServiceCostApi = async (data, id) => {
  const response = await API.put(`settings/courier-service-cost/${id}`, data);
  return { response };
};

export const deleteCourierServiceCostApi = async (id) => {
  const response = await API.delete(`settings/courier-service-cost/${id}`);
  return { response };
};

// ---- Carrier fallback rates (carrier defaults, shipping-method rates, partner return rates) ----

export const getCourierCarriersApi = async (filters) => {
  const response = await API.get("settings/courier-service-cost/carriers", { params: filters });
  return { response };
};

export const updateCourierCarrierApi = async (data, id) => {
  const response = await API.put(`settings/courier-service-cost/carriers/${id}`, data);
  return { response };
};

export const getCourierPairRatesApi = async (resource, filters) => {
  const response = await API.get(`settings/courier-service-cost/${resource}`, { params: filters });
  return { response };
};

export const addCourierPairRateApi = async (resource, data) => {
  const response = await API.post(`settings/courier-service-cost/${resource}`, data);
  return { response };
};

// Pivot rows have no id: they are addressed by carrier id + the second key (shipping_id / partner_id).
export const updateCourierPairRateApi = async (resource, deliveryPartnerId, secondId, data) => {
  const response = await API.put(`settings/courier-service-cost/${resource}/${deliveryPartnerId}/${secondId}`, data);
  return { response };
};

export const deleteCourierPairRateApi = async (resource, deliveryPartnerId, secondId) => {
  const response = await API.delete(`settings/courier-service-cost/${resource}/${deliveryPartnerId}/${secondId}`);
  return { response };
};

export const getCourierLookupApi = async (name) => {
  const response = await API.get(`settings/courier-service-cost/lookups/${name}`);
  return { response };
};
